import React from 'react';
import './Layout.css';

function Layout({ children }) {
    return (
        <div className="layout">
            <header className="layout-header">
                <div className="layout-nav">
                    {/* Navigation will be added in later phases */}
                </div>
            </header>
            <main className="layout-main">
                {children}
            </main>
            <footer className="layout-footer">
                {/* Footer content removed */}
            </footer>
        </div>
    );
}

export default Layout;